
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/equipment",
      function () {
        return require("private-next-pages/equipment/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/equipment"])
      });
    }
  